'use strict';
const angular = require('angular');

export default angular.module('nomasvelloDashboardApp.constants', [])
  .constant('appConfig', require('../../server/config/environment/shared'))
  .name;



// WEBPACK FOOTER //
// ./client/app/app.constants.ts